
/**
 * Function which allows to display or hide the layout Grid design in pushing the 'G' key
 */
export default function () {
    window.addEventListener('keydown', (e) => {
        if (e.code === 'KeyG') {
            if (document.querySelector('.containerGrid').style.display === 'block') {
                document.querySelector('.containerGrid').style.display = 'none';
            } else {
                document.querySelector('.containerGrid').style.display = 'block';
            }
        }
    });
}
